/**
 * Route Permissions Mapping
 * Maps routes and services to their required permissions
 */
import { PERMISSIONS } from "./permissions";

/**
 * Route to Permission mapping
 * Maps each route path to the required permission(s)
 */
export const ROUTE_PERMISSIONS = {
  // Animals
  "/animals": PERMISSIONS.ANIMALS_READ,
  "/AnimalsDetails": PERMISSIONS.ANIMALS_CREATE,
  "/animalCost": PERMISSIONS.ANIMALS_COST,
  "/animalServices": PERMISSIONS.ANIMALS_READ,
  
  // Treatments
  "/treatment": PERMISSIONS.TREATMENTS_CREATE,
  "/treatmentTable": PERMISSIONS.TREATMENTS_READ,
  "/treatmentLocation": PERMISSIONS.TREATMENTS_CREATE,
  "/treatmentAnimal": PERMISSIONS.TREATMENTS_CREATE,
  "/treatAnimalTable": PERMISSIONS.TREATMENTS_READ,
  "/treetmentServices": PERMISSIONS.TREATMENTS_READ,
  "/pharmacy": PERMISSIONS.TREATMENTS_READ,
  
  // Vaccines
  "/addVaccine": PERMISSIONS.VACCINES_CREATE,
  "/vaccineTable": PERMISSIONS.VACCINES_READ,
  "/Vaccinebyanimalsstable": PERMISSIONS.VACCINES_READ,
  "/vaccinebytagid": PERMISSIONS.VACCINES_CREATE,
  "/vaccinebylocationshed": PERMISSIONS.VACCINES_CREATE,
  "/vaccineServices": PERMISSIONS.VACCINES_READ,
  
  // Feed
  "/feed": PERMISSIONS.FEED_CREATE,
  "/feedingTable": PERMISSIONS.FEED_READ,
  "/feedbylocation": PERMISSIONS.FEED_CREATE,
  "/feedlocationtable": PERMISSIONS.FEED_READ,
  "/feedingServices": PERMISSIONS.FEED_READ,
  "/fodder": PERMISSIONS.FEED_CREATE,
  "/fodderTable": PERMISSIONS.FEED_READ,
  "/fodderServices": PERMISSIONS.FEED_READ,
  
  // Breeding
  "/breeding": PERMISSIONS.BREEDING_CREATE,
  "/breadingTable": PERMISSIONS.BREEDING_READ,
  "/breedingServices": PERMISSIONS.BREEDING_READ,
  
  // Mating
  "/mating": PERMISSIONS.MATING_CREATE,
  "/matingTable": PERMISSIONS.MATING_READ,
  "/matingLocation": PERMISSIONS.MATING_CREATE,
  "/matingServices": PERMISSIONS.MATING_READ,
  
  // Weight
  "/weight": PERMISSIONS.WEIGHT_CREATE,
  "/weightTable": PERMISSIONS.WEIGHT_READ,
  "/withGrowthData": PERMISSIONS.WEIGHT_READ,
  "/weightServices": PERMISSIONS.WEIGHT_READ,
  
  // Reports
  "/report": PERMISSIONS.REPORTS_VIEW,
  "/reportServices": PERMISSIONS.REPORTS_VIEW,
  "/reportDaliy": PERMISSIONS.REPORTS_VIEW,
  
  // Excluded
  "/excluded": PERMISSIONS.EXCLUDED_CREATE,
  "/excludedtable": PERMISSIONS.EXCLUDED_READ,
  "/excludedServices": PERMISSIONS.EXCLUDED_READ,
  
  // Location & Breed
  "/locationPost": PERMISSIONS.SETTINGS_MANAGE, // Basic settings
  "/locationTable": PERMISSIONS.SETTINGS_READ,
  "/locationServices": PERMISSIONS.SETTINGS_READ,
  "/breedPost": PERMISSIONS.SETTINGS_MANAGE,
  "/breedTable": PERMISSIONS.SETTINGS_READ,
  "/breedServices": PERMISSIONS.SETTINGS_READ,
  
  // Suppliers
  "/supplier": PERMISSIONS.SETTINGS_MANAGE,
  "/supplierTable": PERMISSIONS.SETTINGS_READ,
  "/SupplierServices": PERMISSIONS.SETTINGS_READ,
  
  // Support - Available to all authenticated users
  // "/support": null, // Commented out to make it available to all
  
  // Notifications
  "/notificationPage": null, // Available to all authenticated users
};

/**
 * Service to Permission mapping
 * Maps service routes to required permissions
 */
export const SERVICE_PERMISSIONS = {
  "/locationServices": PERMISSIONS.SETTINGS_READ,
  "/breedServices": PERMISSIONS.SETTINGS_READ,
  "/SupplierServices": PERMISSIONS.SETTINGS_READ,
  "/animalServices": PERMISSIONS.ANIMALS_READ,
  "/matingServices": PERMISSIONS.MATING_READ,
  "/breedingServices": PERMISSIONS.BREEDING_READ,
  "/weightServices": PERMISSIONS.WEIGHT_READ,
  "/vaccineServices": PERMISSIONS.VACCINES_READ,
  "/pharmacy": PERMISSIONS.TREATMENTS_READ,
  "/treetmentServices": PERMISSIONS.TREATMENTS_READ,
  "/animalCost": PERMISSIONS.ANIMALS_COST,
  "/feedingServices": PERMISSIONS.FEED_READ,
  "/fodderServices": PERMISSIONS.FEED_READ,
  "/reportServices": PERMISSIONS.REPORTS_VIEW,
  "/excludedServices": PERMISSIONS.EXCLUDED_READ,
};

/**
 * Sidebar menu item to permission mapping
 * Maps sidebar menu items to required permissions
 */
export const SIDEBAR_MENU_PERMISSIONS = {
  // Supplier section
  "/supplierTable": PERMISSIONS.SETTINGS_READ,
  "/supplier": PERMISSIONS.SETTINGS_MANAGE,
  
  // Location Shed
  "/locationTable": PERMISSIONS.SETTINGS_READ,
  "/locationPost": PERMISSIONS.SETTINGS_MANAGE,
  
  // Breed
  "/breedTable": PERMISSIONS.SETTINGS_READ,
  "/breedPost": PERMISSIONS.SETTINGS_MANAGE,
  
  // Animals
  "/animals": PERMISSIONS.ANIMALS_READ,
  "/AnimalsDetails": PERMISSIONS.ANIMALS_CREATE,
  "/animalCost": PERMISSIONS.ANIMALS_COST,
  
  // Mating
  "/matingTable": PERMISSIONS.MATING_READ,
  "/mating": PERMISSIONS.MATING_CREATE,
  "/matingLocation": PERMISSIONS.MATING_CREATE,
  
  // Vaccine
  "/vaccineTable": PERMISSIONS.VACCINES_READ,
  "/Vaccinebyanimalsstable": PERMISSIONS.VACCINES_READ,
  "/addVaccine": PERMISSIONS.VACCINES_CREATE,
  "/vaccinebytagid": PERMISSIONS.VACCINES_CREATE,
  "/vaccinebylocationshed": PERMISSIONS.VACCINES_CREATE,
  
  // Pharmacy
  "/treatmentTable": PERMISSIONS.TREATMENTS_READ,
  "/treatment": PERMISSIONS.TREATMENTS_CREATE,
  
  // Treatment
  "/treatAnimalTable": PERMISSIONS.TREATMENTS_READ,
  "/treatmentAnimal": PERMISSIONS.TREATMENTS_CREATE,
  "/treatmentLocation": PERMISSIONS.TREATMENTS_CREATE,
  
  // Weight
  "/weightTable": PERMISSIONS.WEIGHT_READ,
  "/weight": PERMISSIONS.WEIGHT_CREATE,
  "/withGrowthData": PERMISSIONS.WEIGHT_READ,
  
  // Breeding
  "/breadingTable": PERMISSIONS.BREEDING_READ,
  "/breeding": PERMISSIONS.BREEDING_CREATE,
  
  // Feeding
  "/feedingTable": PERMISSIONS.FEED_READ,
  "/feed": PERMISSIONS.FEED_CREATE,
  "/feedlocationtable": PERMISSIONS.FEED_READ,
  "/feedbylocation": PERMISSIONS.FEED_CREATE,
  
  // Fodder
  "/fodderTable": PERMISSIONS.FEED_READ,
  "/fodder": PERMISSIONS.FEED_CREATE,
  
  // Reports
  "/report": PERMISSIONS.REPORTS_VIEW,
  
  // Dashboard
  "/userDashboard": PERMISSIONS.STATISTICS_VIEW,
  
  // Excluded
  "/excludedtable": PERMISSIONS.EXCLUDED_READ,
  "/excluded": PERMISSIONS.EXCLUDED_CREATE,
  
  // Home - Available to all authenticated users (null means no permission required)
  "/": null,
  
  // Support - Available to all authenticated users (null means no permission required)
  "/support": null,
  
  // Notifications - Available to all authenticated users
  "/notificationPage": null,
};

/**
 * Action permissions mapping
 * Maps actions (create, update, delete) to permissions
 */
export const ACTION_PERMISSIONS = {
  create: {
    animals: PERMISSIONS.ANIMALS_CREATE,
    excluded: PERMISSIONS.EXCLUDED_CREATE,
    treatments: PERMISSIONS.TREATMENTS_CREATE,
    vaccines: PERMISSIONS.VACCINES_CREATE,
    feed: PERMISSIONS.FEED_CREATE,
    breeding: PERMISSIONS.BREEDING_CREATE,
    mating: PERMISSIONS.MATING_CREATE,
    weight: PERMISSIONS.WEIGHT_CREATE,
  },
  update: {
    animals: PERMISSIONS.ANIMALS_UPDATE,
    excluded: PERMISSIONS.EXCLUDED_UPDATE,
    treatments: PERMISSIONS.TREATMENTS_UPDATE,
    vaccines: PERMISSIONS.VACCINES_UPDATE,
    feed: PERMISSIONS.FEED_UPDATE,
    breeding: PERMISSIONS.BREEDING_UPDATE,
    mating: PERMISSIONS.MATING_UPDATE,
    weight: PERMISSIONS.WEIGHT_UPDATE,
  },
  delete: {
    animals: PERMISSIONS.ANIMALS_DELETE,
    excluded: PERMISSIONS.EXCLUDED_DELETE,
    treatments: PERMISSIONS.TREATMENTS_DELETE,
    vaccines: PERMISSIONS.VACCINES_DELETE,
    feed: PERMISSIONS.FEED_DELETE,
    breeding: PERMISSIONS.BREEDING_DELETE,
    mating: PERMISSIONS.MATING_DELETE,
    weight: PERMISSIONS.WEIGHT_DELETE,
  },
};

/**
 * Check if user can access a route
 * @param {string} path - Route path
 * @param {string[]} userPermissions - User's permissions
 * @returns {boolean}
 */
export const canAccessRoute = (path, userPermissions) => {
  if (!userPermissions || userPermissions.length === 0) return false;
  
  // Owner has access to everything
  if (userPermissions.includes(PERMISSIONS.OWNER)) return true;
  
  const requiredPermission = ROUTE_PERMISSIONS[path];
  
  // If no permission required, allow access
  if (!requiredPermission) return true;
  
  return userPermissions.includes(requiredPermission);
};

/**
 * Check if user can access a service
 * @param {string} servicePath - Service path
 * @param {string[]} userPermissions - User's permissions
 * @returns {boolean}
 */
export const canAccessService = (servicePath, userPermissions) => {
  if (!userPermissions || userPermissions.length === 0) return false;
  
  // Owner has access to everything
  if (userPermissions.includes(PERMISSIONS.OWNER)) return true;
  
  const requiredPermission = SERVICE_PERMISSIONS[servicePath];
  
  // If no permission required, allow access
  if (!requiredPermission) return true;
  
  return userPermissions.includes(requiredPermission);
};

/**
 * Check if user can perform an action
 * @param {string} action - Action type (create, update, delete)
 * @param {string} resource - Resource type (animals, treatments, etc.)
 * @param {string[]} userPermissions - User's permissions
 * @returns {boolean}
 */
export const canPerformAction = (action, resource, userPermissions) => {
  if (!userPermissions || userPermissions.length === 0) return false;
  
  // Owner can perform all actions
  if (userPermissions.includes(PERMISSIONS.OWNER)) return true;
  
  const requiredPermission = ACTION_PERMISSIONS[action]?.[resource];
  
  if (!requiredPermission) return false;
  
  return userPermissions.includes(requiredPermission);
};

/**
 * Filter menu items based on permissions
 * @param {Array} menuItems - Menu items array
 * @param {string[]} userPermissions - User's permissions
 * @returns {Array} Filtered menu items
 */
export const filterMenuItems = (menuItems, userPermissions, isEmployee = false) => {
  if (!userPermissions || userPermissions.length === 0) {
    // If no permissions and is employee, show only Home and Support
    if (isEmployee) {
      return menuItems.map(section => ({
        ...section,
        items: section.items.filter(item => 
          item.path === "/" || item.path === "/support" || item.path === "/notificationPage"
        ),
      })).filter(section => section.items.length > 0);
    }
    return [];
  }
  
  // Owner sees everything
  if (userPermissions.includes(PERMISSIONS.OWNER)) return menuItems;
  
  // Always allow Home, Support, and Notifications (null permissions)
  const alwaysAllowedPaths = ["/", "/support", "/notificationPage"];
  
  return menuItems.map(section => ({
    ...section,
    items: section.items
      .map(item => {
        // Helper function to filter subItems
        const filterSubItems = (subItems) => {
          return subItems.filter(subItem => {
            const subPermission = SIDEBAR_MENU_PERMISSIONS[subItem.path];
            // If subPermission is null, it means no permission required (available to all)
            if (subPermission === null) {
              return true;
            }
            // If subPermission exists and is not null, check if user has it
            if (subPermission !== undefined && subPermission !== null) {
              return userPermissions.includes(subPermission);
            }
            // If subPermission is undefined and is employee, hide it
            if (isEmployee && subPermission === undefined) {
              return false;
            }
            // For non-employees, if undefined, show it (backward compatibility)
            return !isEmployee;
          });
        };

        // Always allow Home, Support, and Notifications
        if (item.path && alwaysAllowedPaths.includes(item.path)) {
          // If it has subItems, still filter them
          if (item.subItems) {
            const filteredSubItems = filterSubItems(item.subItems);
            if (filteredSubItems.length === 0) {
              return item; // Still show the item even if no subItems (it's Home/Support/Notifications)
            }
            return {
              ...item,
              subItems: filteredSubItems,
            };
          }
          return item;
        }
        
        // If item has subItems but no direct path (like "Supplier", "Location Shed", etc.)
        if (item.subItems && !item.path) {
          const filteredSubItems = filterSubItems(item.subItems);
          // Only show the parent item if it has at least one visible subItem
          if (filteredSubItems.length === 0) {
            return null;
          }
          return {
            ...item,
            subItems: filteredSubItems,
          };
        }
        
        // If item has both path and subItems
        if (item.path && item.subItems) {
          // Check main item permission first
          const itemPermission = SIDEBAR_MENU_PERMISSIONS[item.path];
          
          // If itemPermission is null, it means no permission required
          if (itemPermission === null) {
            const filteredSubItems = filterSubItems(item.subItems);
            if (filteredSubItems.length === 0) {
              return null;
            }
            return {
              ...item,
              subItems: filteredSubItems,
            };
          }
          
          // If itemPermission is undefined and is employee, hide it
          if (isEmployee && itemPermission === undefined) {
            return null;
          }
          
          // If itemPermission exists and is not null, check if user has it
          if (itemPermission !== undefined && itemPermission !== null) {
            if (!userPermissions.includes(itemPermission)) {
              return null;
            }
          }
          
          // Filter subItems
          const filteredSubItems = filterSubItems(item.subItems);
          if (filteredSubItems.length === 0) {
            return null;
          }
          return {
            ...item,
            subItems: filteredSubItems,
          };
        }
        
        // If item has only path (no subItems)
        if (item.path && !item.subItems) {
          const itemPermission = SIDEBAR_MENU_PERMISSIONS[item.path];
          
          // If itemPermission is null, it means no permission required
          if (itemPermission === null) {
            return item;
          }
          
          // If itemPermission is undefined and is employee, hide it
          if (isEmployee && itemPermission === undefined) {
            return null;
          }
          
          // If itemPermission exists and is not null, check if user has it
          if (itemPermission !== undefined && itemPermission !== null) {
            if (!userPermissions.includes(itemPermission)) {
              return null;
            }
          }
          
          // For non-employees, if undefined, show it (backward compatibility)
          if (!isEmployee && itemPermission === undefined) {
            return item;
          }
          
          return item;
        }
        
        // Fallback: if no path and no subItems, hide it for employees
        if (isEmployee) {
          return null;
        }
        
        return item;
      })
      .filter(item => item !== null),
  })).filter(section => section.items.length > 0);
};

